import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { storeAppDispatch } from './../GlobalState/Store';
import { setPlayerData } from './../GlobalState/UserReducer';
import { Link, useHistory } from "react-router-dom";
import { toast } from "react-toastify"
import { Animated } from "react-animated-css";
import { UserService } from '../UserService';
import ExitIcon from '../images/exit.png';
import { setActiveTab } from '../GlobalState/MenuReducer';
import { client } from '../helpers/client';
import { AnonAdLanding } from '../components/Ads';
import CsLogo from '../images/cs-logo.png';
import { Events } from '../components/LandingPage/Events';
import '../scss/pages/landingPage.scss';


export const LandingPage = () => {
    const history = useHistory();
    const UserState = useSelector((store) => store.user);
    const userNameInputRef = useRef(null);

    const [userName, setUserName] = useState(localStorage.getItem('username'));
    const [isLoading, setIsLoading] = useState(false);

    const [fullyMounted, isFullyMounted] = useState(false);

    let usernameLetters = null;
    const cacheUname = () => usernameLetters && localStorage.setItem('username', usernameLetters);

    const handleLoginClick = () => {
      setIsLoading(true);
      cacheUname();
    };

    useEffect(() => {
        usernameLetters = userName;
    }, [userName]);

    useEffect(() => {
        if (!UserState.isLogged && UserState.loginType === "keychain") {
            userNameInputRef.current.focus();
        }
    }, [UserState.loginType]);

    useEffect(() => {
      setTimeout(() => isFullyMounted(true), 1);
    }, []);

    const login_hivesigner = () => {
        toast.warning("not implemented yet!");
    };

    const display_login_keychain = () => {
        if (window.hive_keychain) {
            let keychain = window.hive_keychain
            console.log('hive  keychain handshake!')
            keychain.requestHandshake(() => {
                const currentState = { ...UserState, loginType: "keychain" }
                storeAppDispatch(setPlayerData(currentState));
                console.log("handshake success!", UserState);
            });
        } else {
            const currentState = { ...UserState, error: "You do not have hive keychain installed" }
            storeAppDispatch(setPlayerData(currentState));
            toast.error("Handshake failed!");
        }
    };

    const login_keychain_submit = async (e) => {
      e.preventDefault();
      if (!window.hive_keychain) {
        setIsLoading(false);
        toast.error("Hive keychain browser extension not found!");
        return;
      }
      let keychain = window.hive_keychain;
      if (!userName) {
        setIsLoading(false);
        return toast.warning('Put your username');
      }
      try {
        const message = userName + '_' + Date.now();
        keychain.requestSignBuffer(
          userName,
          message,
          "Posting",
          async function (response) {
            console.log('response of requestSignBuffer:', response);
            if (response.error) {
                console.log('hive keychain error:', response.error)
                toast.error("failed requestSignBuffer!");
                setIsLoading(false);
            } else {
              let username = response.data.username
              console.log('response data', response.data)
              toast.success("Request signed and broadcasted");
              
              const resHiveUserVerify = await client.post('/api/auth/verify', { username, message, signed_message: response.result });
              if (resHiveUserVerify.status === 200 && resHiveUserVerify.data.result === "success") {
                toast.success("Hive user is verified on backend successfully! ")
                const currentState = { ...UserState, username, isLogged: true };
                storeAppDispatch(setPlayerData(currentState));
                history.push('/home');
                storeAppDispatch(setActiveTab({ activeTab: 1 }));
              } else {
                toast.error("Hive user verify on backend is failed! ")
                const currentState = { ...UserState, username, isLogged: false };
                storeAppDispatch(setPlayerData(currentState));
                history.push('/login');
                setIsLoading(false);
              }
            }
          }
        );
      } catch (err) {
        setIsLoading(false);
        console.log(err);
        toast.error("Uh oh, something broke!");
      }
    }

    const onHandleLogout = () => {
        UserService.logout();
    }


    return (<>
      <Animated animationIn="fadeInDown" animationOut="slideOutLeft" animationInDuration={500} animationInDelay={50} animationOutDuration={300} isVisible={true}>
        <div className="landing fadeInDown">
          <div className="row">
            <div className="col-1"></div>
            <div className="col-3 row">
              <div id="form-content">
                <div className="" id="cs-logo-wrap">
                  <img src={CsLogo} alt="CS-logo" />
                </div>
                <h1 className="mt-1 landing-title">Hive NFT Marketplace</h1>
                <div id="hive-logo-wrap" className="fadeIn first">
                    <img src="./hive_symbol.png" alt="hive icon" style={{ width: "150px" }}/>
                </div>
                {(!UserState.isLogged && UserState.loginType === "") && (
                  <div id="login-form-wrap">
                    <span style={{ color: "red" }}>{UserState.error}</span>
                    {/* <button id="hivesigner-login" className="btn-primary btn-block btn-login disabled" onClick={login_hivesigner} disabled="true">Log in with Hivesigner</button> */}
                    <button
                      id="keychain-login"
                      className="btn-primary btn-block btn-login mb-2"
                      onClick={display_login_keychain}
                    >
                      Log in with Hive Keychain
                    </button>
                    <div id="installers">
                      <span className="boldo">No keychain extension?</span>
                      <br/>Click <a id="keychain-installer" href="https://chrome.google.com/webstore/detail/hive-keychain/jcacnejopjdphbnjgfaaobbfafkihpep?hl=en" className="link" target="_blank" rel="noreferrer">here</a> to install.
                      <p id="free-invite"><span className="boldo">No Hive account yet?</span>
                      <br/>Create one for FREE <a href="https://hiveonboard.com?ref=cryptoshots.nft" target="_blank" rel="noreferrer" id="account-invite"><span className="boldo">here</span></a></p>
                    </div>
                  </div>
                )}
                {(!UserState.isLogged && UserState.loginType === "keychain") && (
                    <>
                        <span style={{ color: "red" }}>{UserState.error}</span>
                        <form onSubmit={login_keychain_submit} style={{ margin: '40px auto', width: '80%' }}>
                            <input
                              id="hive-username"
                              ref={userNameInputRef} className="form-control form-control-sm" placeholder="Username" value={userName}
                              autoComplete="off"
                              style={{ color: 'black' }}
                              onChange={e => setUserName(e.target.value)}
                            />
                            <button
                              type="submit" className="btn-primary btn-block btn-login mb-2"
                              style={{ color: 'black', fontSize: '18px' }}
                              onClick={handleLoginClick}
                            >
                              <img
                                src="https://www.glyphicons.com/img/glyphicons/basic/2x/glyphicons-basic-431-log-in@2x.png"
                                alt="Loggin" width="24"
                                style={{ marginBottom: '4px' }}
                              /> &nbsp;
                              {isLoading
                                ? <i class="fa fa-spinner fa-spin" style={{ fontSize: '24px' }}></i>
                                : <span style={{ fontWeight: 'bold' }}>LOGIN</span>}

                            </button>
                        </form>
                    </>
                )}
                {UserState.isLogged && <div id="logout-wrap">
                    <h4 className='mt-3'>Open session: <span className="boldo">@{UserState.username}</span></h4>
                    <br/><br/>
                    <Link to="/" className="btn-item" onClick={onHandleLogout}>Logout <img src={ExitIcon} alt="Exit" width="24" /></Link>
                  </div>
                }
              </div>
            </div>
            <Events />

            {fullyMounted && 
              <div
                id="xWidget"
                className="col-3"
                style={{ height: '75vh', overflow: 'auto' }}
              >
                <div
                  id="twitter-widget"
                  style={{ backgroundColor: 'black', textAlign: 'center' }}
                >
                  <a
                      class="twitter-timeline"
                      data-theme="dark"
                      href="https://twitter.com/cryptoshots_nft?ref_src=twsrc%5Etfw"
                    >
                      Our Recent Tweets
                    </a>
                </div>

                {/* <AnonAdLanding /> */}
              </div>
            }
          </div>
        </div>
      </Animated>
    </>);
};
